'use strict';
import angular from 'angular';

angular.module('app.services')

.factory('QueuesFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
    var factory = {};

    factory.queues = function() {
        return $resource(AppConfig.IO_API_URL + 'queues', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.allQueues = function() {
        return $resource(AppConfig.IO_API_URL + 'queues/allQueues', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.queue = function() {
        return $resource(AppConfig.IO_API_URL + 'queues/queue', null, {
            'get': {
                method: 'GET',
                isArray: false
            },
            'save': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method: 'PUT',
                isArray: false
            }
        });
    };

    factory.queuesForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'queues/queuesForCurrentUser', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.queuedTaskSummary = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/queuedTaskSummary', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.queuedTaskSummaryForCurrentUser = function() {
        return $resource(AppConfig.IO_API_URL + 'tasks/queuedTaskSummaryForCurrentUser', null, {
            'save': {
                method: 'POST',
                isArray: false
            }
        });
    };

    factory.queueTypes = function() {
        return $resource(AppConfig.IO_API_URL + 'queues/queueTypes', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.toggleQueueState = function() {
        return $resource(AppConfig.IO_API_URL + 'queues/toggleQueueState', null, {
            'update': {
                method: 'PUT'
            }
        });
    };

    return factory;
}])

.factory('QueuesService', ['QueuesFactory', '$q', function(QueuesFactory, $q) {
    var service = {};
    service.queues = [];
    service.queue = null;
    service.taskAssignments = null;
    service.queueTypes = null;

    // Get all queues for a cluster
    service.getQueues = function(clusterIds, active) {
        var deferred = $q.defer();
        var params = {
            'clusterIds[]': clusterIds,
            'active': active
        };

        QueuesFactory.queues().get(params).$promise.then(function(data) {
            service.queues = data.queues || [];
            deferred.resolve();
        }, function(response) {
            console.log("error getting queues for cluster " + clusterId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getAllQueues = function() {
        var deferred = $q.defer();

        QueuesFactory.allQueues().get().$promise.then(function(data) {
            service.queues = data.queues || [];
            deferred.resolve();
        }, function(response) {
            console.log("error getting all queues");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getQueue = function(queueId) {
        var deferred = $q.defer();
        var params = {
            'id': queueId
        };

        QueuesFactory.queue().get(params).$promise.then(function(data) {
            service.queue = data.queue;
            deferred.resolve();
        }, function(response) {
            console.log("error getting queue for Id " + queueId);
            deferred.reject();
        });
        return deferred.promise;
    };

    service.saveQueue = function(queueObj) {
        var deferred = $q.defer();

        QueuesFactory.queue().save(queueObj).$promise.then(function(data) {
            deferred.resolve();
        }, function(response) {
            console.log("error saving queue");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.updateQueue = function(queueObj) {
        var deferred = $q.defer();

        QueuesFactory.queue().update(queueObj).$promise.then(function(data) {
            deferred.resolve();
        }, function(response) {
            console.log("error updating queue");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get all queues available to the current user
    service.getQueuesForCurrentUser = function(clusterIds) {
        var deferred = $q.defer();
        var params = {
            'clusterIds': clusterIds
        };

        QueuesFactory.queuesForCurrentUser().save().$promise.then(function(data) {
            service.queues = data.queues || [];
            deferred.resolve();
        }, function(response) {
            console.log("error getting queues for the current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get QueuedTaskSummary
    service.getQueuedTaskSummary = function(clusterIds) {
        var deferred = $q.defer();
        var params = {
            'clusterIds': clusterIds
        };

        QueuesFactory.queuedTaskSummary().save(params).$promise.then(function(data) {
            service.queuedTaskSummary = data.queuedTaskSummary || [];
            deferred.resolve();
        }, function(response) {
            console.log("error getting queued task summary");
            deferred.reject();
        });
        return deferred.promise;
    };

    // Get QueuedTaskSummary For Current User
    service.getQueuedTaskSummaryForCurrentUser = function(clusterIds) {
        var deferred = $q.defer();
        var params = {
            'clusterIds': clusterIds
        };

        QueuesFactory.queuedTaskSummaryForCurrentUser().save(params).$promise.then(function(data) {
            service.queuedTaskSummary = data.queuedTaskSummary || [];
            deferred.resolve();
        }, function(response) {
            console.log("error getting queued task summary for current user");
            deferred.reject();
        });
        return deferred.promise;
    };

    service.getQueueTypes = function() {
        var deferred = $q.defer();

        QueuesFactory.queueTypes().get().$promise.then(function(data) {
            service.queueTypes = data.queueTypes;
            deferred.resolve();
        }, function(response) {
            console.log("error getting queues types for the current user");
            deferred.reject();
        });
        return deferred.promise;
    };
    service.toggleState = function(params) {
        var deferred = $q.defer();
        // params = {};


        QueuesFactory.toggleQueueState().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(response) {
            console.log("Error updating tasks state");
            deferred.reject();
        });
        return deferred.promise;
    };

    return service;
}]);
